
export const projectList = [
    {
        name: 'Current Portfolio',
        logo: '/projects/new_me/new_me.png',
        url: 'https://www.aepere.space', 
        logoBgColor: '', 
        description: 'The second/current version of my portfolio.',
    },
    {
        name: 'EKO-Lavida',
        logo: '/projects/ekolavida/ekolavida.png',
        logoBgColor: '#FF5673', 
        url: 'https://www.ekolavida.com',
        description: 'An Afro-centric event experience creating an environment to meet new friends, savor Afro-Caribbean flavors, groove to great Afrobeats, Amapiano and Dancehall tunes in the diaspora.'
    },
    {
        name: 'Port Harcourt Food Bank',
        logo: '/projects/foodbank/foodbank.png',
        logoBgColor: '#779242', 
        url: 'https://www.portharcourtfoodbank.com',
        description: 'A recognized nonprofit organization dedicated to combating extreme hunger, malnutrition and food insecurity in Rivers State.',
    },
    {
        name: 'Usource',
        logo: '/projects/usource/usource.png',
        url: 'https://play.google.com/store/apps/details?id=com.usource.app',
        logoBgColor: '#07075E',
        description: 'A Mobile-Based Solution for Efficient Workforce Management.',
    },
    {
        name: 'Marg Education',
        logo: '/projects/margeducation/margeducation.png',
        url: 'https://www.margeducation.online',
        logoBgColor: '#665BC1',
        description: 'An admin system that manages the resources of the company, making easier to assist clients in getting to their desired Educational Institution.',
    },
    {
        name: 'Previous Portfolio',
        logo: '/projects/old_me/old_me.png',
        url: 'https://ape-niche.web.app/',
        logoBgColor: '#fff',
        description: 'The first version of my portfolio, never forget your humble beginnings. Information here may be obsolete',
    },
]